import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { AUTH_API_URL, LOGO_SRC } from "../config";
import { authHeaders, storeSession } from "../lib/auth";
import { buttons } from "./site/ui";

// Google sign-in lands here with ?token=..., or on /auth-error if it failed.
function AuthSuccess({ failed = false }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(failed);

  useEffect(() => {
    if (failed) return undefined;
    const token = searchParams.get("token");
    if (!token) {
      navigate("/", { replace: true });
      return undefined;
    }

    let cancelled = false;
    axios
      .get(`${AUTH_API_URL}/api/auth/profile`, { headers: authHeaders(token) })
      .then(({ data }) => {
        if (cancelled) return;
        storeSession(token, { id: data._id, email: data.email, firstName: data.firstName, lastName: data.lastName });
        navigate("/", { replace: true });
      })
      .catch((requestError) => {
        console.error("Error fetching user data:", requestError);
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [failed, navigate, searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
        <img src={LOGO_SRC} alt="Car Sense" className="mx-auto h-12 w-12" />
        {error ? (
          <>
            <h1 className="mt-5 text-lg font-semibold text-slate-900">We couldn't sign you in with Google</h1>
            <p className="mt-2 text-sm text-slate-600">Please try again, or sign in with your email and password.</p>
            <Link to="/" className={`${buttons.primary} mt-6 w-full`}>
              Back to Car Sense
            </Link>
          </>
        ) : (
          <div role="status">
            <span
              className="mx-auto mt-6 block h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600"
              aria-hidden="true"
            />
            <h1 className="mt-5 text-lg font-semibold text-slate-900">Signing you in…</h1>
            <p className="mt-1 text-sm text-slate-600">You'll be back on Car Sense in a moment.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuthSuccess;
